/**
 * Curated email header banner colors for Trader / Independent Sales users.
 * Keep in sync with App\Support\EmailBannerColor::PRESETS on the backend.
 */
export interface EmailBannerColorOption {
    id: string;
    name: string;
    from: string;
    to: string;
    text: string;
}

export const EMAIL_BANNER_COLORS: EmailBannerColorOption[] = [
    { id: 'navy-slate', name: 'Navy Slate', from: '#1e293b', to: '#334155', text: '#ffffff' },
    { id: 'black', name: 'Black', from: '#000000', to: '#1a1a1a', text: '#ffffff' },
    { id: 'midnight-blue', name: 'Midnight Blue', from: '#0f172a', to: '#1e3a5f', text: '#ffffff' },
    { id: 'forest-green', name: 'Forest Green', from: '#14532d', to: '#166534', text: '#ffffff' },
    { id: 'burgundy', name: 'Burgundy', from: '#7f1d1d', to: '#991b1b', text: '#ffffff' },
    { id: 'royal-purple', name: 'Royal Purple', from: '#4c1d95', to: '#6d28d9', text: '#ffffff' },
    { id: 'teal-deep', name: 'Deep Teal', from: '#0f766e', to: '#115e59', text: '#ffffff' },
    { id: 'charcoal', name: 'Charcoal', from: '#18181b', to: '#3f3f46', text: '#ffffff' },
    { id: 'cobalt', name: 'Cobalt', from: '#1e3a8a', to: '#2563eb', text: '#ffffff' },
    { id: 'wine', name: 'Wine', from: '#831843', to: '#9d174d', text: '#ffffff' },
    { id: 'ocean', name: 'Ocean', from: '#0c4a6e', to: '#075985', text: '#ffffff' },
    { id: 'sky-blue', name: 'Sky Blue', from: '#e0f2fe', to: '#bae6fd', text: '#0f172a' },
    { id: 'mint', name: 'Mint', from: '#d1fae5', to: '#a7f3d0', text: '#14532d' },
    { id: 'lavender', name: 'Lavender', from: '#ede9fe', to: '#ddd6fe', text: '#4c1d95' },
    { id: 'peach', name: 'Peach', from: '#ffedd5', to: '#fed7aa', text: '#9a3412' },
    { id: 'rose', name: 'Rose', from: '#ffe4e6', to: '#fecdd3', text: '#9f1239' },
    { id: 'lemon', name: 'Lemon', from: '#fef9c3', to: '#fde047', text: '#713f12' },
    { id: 'sand', name: 'Sand', from: '#fef3c7', to: '#fde68a', text: '#78350f' },
    { id: 'glacier', name: 'Glacier', from: '#ecfeff', to: '#cffafe', text: '#155e75' },
    { id: 'lilac', name: 'Lilac', from: '#fae8ff', to: '#f5d0fe', text: '#701a75' },
    { id: 'slate-light', name: 'Light Slate', from: '#f1f5f9', to: '#e2e8f0', text: '#1e293b' },
];

export const DEFAULT_EMAIL_BANNER_COLOR_ID = 'navy-slate';

export function emailBannerGradient(option: EmailBannerColorOption): string {
    return `linear-gradient(135deg, ${option.from} 0%, ${option.to} 100%)`;
}

export function findEmailBannerColor(id?: string | null): EmailBannerColorOption {
    return EMAIL_BANNER_COLORS.find((c) => c.id === id) ?? EMAIL_BANNER_COLORS[0];
}
